// extracted by mini-css-extract-plugin
export default {"menuLink":"NavigationItem_menuLink__FWSXP"};